import { useState, useEffect, useRef } from 'react';
import { collection, onSnapshot, doc } from 'firebase/firestore';
import { db } from '../lib/firebase';

export const useFirebaseConnection = () => {
  const [isConnected, setIsConnected] = useState(false);
  const unsubscribeRef = useRef<(() => void) | null>(null);

  useEffect(() => {
    const setupConnection = async () => {
      try {
        // Unsubscribe from previous listener if exists
        if (unsubscribeRef.current) {
          unsubscribeRef.current();
          unsubscribeRef.current = null;
        }

        const connectionRef = doc(collection(db, '_connection'));
        
        // Set up new listener
        unsubscribeRef.current = onSnapshot(connectionRef, (snapshot) => {
          setIsConnected(snapshot.exists());
        }, (error) => {
          console.error('Firebase connection error:', error);
          setIsConnected(false);
        });
      } catch (error) {
        console.error('Error setting up Firebase connection:', error);
        setIsConnected(false);
      }
    };

    setupConnection();

    // Cleanup function
    return () => {
      if (unsubscribeRef.current) {
        unsubscribeRef.current();
        unsubscribeRef.current = null;
      }
    };
  }, []);

  return isConnected;
};